var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_c('nav',[_c('ul',{staticClass:"footer-menu"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/dashboard'}}})],1)])]),_c('div',{staticClass:"copyright"},[_vm._v("\n      © "+_vm._s(_vm.year)+" Yooga Tecnologia\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }